/*
 *   File : confirmation-modal.js
 *   Author : https://evoqins.com
 *   Description : confirmation modal component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { PrimaryButton } from "../Buttons";

/* ---------- Overlay Component ---------- */
const ModalOverlay = ({ onClose }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prev);
  }, []);

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-25"
      style={{ zIndex: 1040 }}
      onClick={onClose}
    />
  );
};

/* ---------- Confirmation Modal Component ---------- */
export default function ConfirmationModal({
  open = false,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "Cancel",
  loading = false,
}) {
  if (!open) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <ModalOverlay onClose={onCancel} />

      {/* Modal Box */}
      <div
        className="position-fixed overflow-hidden top-50 start-50 translate-middle e-modal-portal rounded-28 shadow p-0"
        style={{
          zIndex: 1055,
          width: "600px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Content */}
        <div className="d-flex e-bg-blur-20 flex-column row-gap-3 justify-content-start bg-white bg-opacity-80 align-items-start p-24">
          {/* <img
            src={
              require("../../Assets/Images/Components/Modal/warning.svg")
                .default
            }
            alt="Confirmation Image"
          /> */}

          {/* Title */}
          {title && (
            <h5 className="fw-500 fs-14 text-start lh-24 text-eerie-black mb-0">
              {title}
            </h5>
          )}

          {/* Message */}
          <div className="row w-100">
            <div className="col-12">
              <h3 className="fw-400 fs-14 text-start lh-24 text-eerie-black mb-0">
                {message || "Are you sure you want to continue?"}
              </h3>
            </div>
          </div>

          {/* Footer Buttons */}
          <div className="row w-100 pt-2">
            <div className="col-6">
              <PrimaryButton
                name={cancelText || "Cancel"}
                ClassName="rounded-pill bg-transparent border-oxford-blue lh-24 py-3 text-oxford-blue w-100 fs-16 fw-500"
                onPress={onCancel}
              />
            </div>
            <div className="col-6">
              <PrimaryButton
                name={confirmText || "Confirm"}
                ClassName="rounded-pill bg-oxford-blue lh-24 py-3 text-white w-100 fs-16 fw-500"
                loading={loading}
                disabled={loading}
                onPress={onConfirm}
              />
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
}
